import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TPostUploadI9DocumentRequest,
  TPostUploadI9DocumentResponse,
} from "./postUploadI9DocumentSchema";

export const postUploadI9Document = (axios: IAxiosInstance) => {
  return async (params: TPostUploadI9DocumentRequest) => {
    const formData = new FormData();
    formData.append("document_type", params.document_type);

    // Handle files - can be FileList or array of Files
    if (params.files) {
      if (params.files instanceof FileList) {
        Array.from(params.files).forEach((file) => {
          formData.append("files", file);
        });
      } else if (Array.isArray(params.files)) {
        params.files.forEach((file) => {
          formData.append("files", file);
        });
      }
    }

    const response = await axios.noRetry.post<TPostUploadI9DocumentResponse>(
      `/api/employees/${params.employeeID}/i9-documents`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  };
};
